<!-- 操作日志页面 -->
<template>
  <div :class="['operation-log-page', { 'operation-log-page--dialog': mode === 'dialog' }]">
    <div v-if="mode !== 'dialog'" class="page-head">
      <img class="page-head__toolbar" src="@/assets/banner/top.png" alt="" />
      <h2 class="page-head__title">{{ pageTitle }}</h2>
    </div>

    <div class="operation-log-body">
      <div class="operation-log-panel ui-table">
        <div class="list-header">
          <div class="search-query ui-search-bar">
            <div v-if="mode === 'domain'" class="search-item ui-control-border">
              <span class="ui-search-label">站点</span>
              <el-select v-model="params.station_id" placeholder="请选择站点" clearable>
                <el-option v-for="item in siteOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </div>
            <div class="search-item ui-control-border search-time-field">
              <span class="ui-search-label">日期</span>
              <el-date-picker
                v-model="defaultDateStr"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="YYYY-MM-DD HH:mm:ss"
                :clearable="false"
                @change="handleDatePicker"
              />
            </div>
            <div class="search-item ui-control-border">
              <span class="ui-search-label">状态</span>
              <el-select v-model="params.state" placeholder="请选择" clearable @change="handleChange">
                <el-option v-for="item in operationStateOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </div>
            <div class="search-item ui-control-border">
              <span class="ui-search-label">类型</span>
              <el-select
                v-model="type"
                placeholder="请选择"
                clearable
                multiple
                filterable
                allow-create
                collapse-tags
                collapse-tags-tooltip
                :max-collapse-tags="3"
                @change="handleChange"
              >
                <el-option v-for="item in operationTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </div>
            <div class="search-actions ui-search-actions">
              <el-button type="primary" class="ui-action-btn" @click="getAlarmList()">查询</el-button>
            </div>
          </div>
        </div>

        <TableRender
          ref="dataTableRef"
          class="operation-log-table"
          :loading="tableLoading"
          :table-data="tableData"
          :table-header="colomns"
          :is-show-index="true"
          :cut-height="tableCutHeight"
          :height="mode === 'dialog' ? '100%' : undefined"
        />
      </div>
    </div>

    <Dialog title="查看操作日志详情" width="800px" v-model:visible="visible">
      <div style="height: 100%">
        <JsonEditor style="height: 100%" ref="jsoneditor3" v-model="jsonData" :modeList="['view']" currentMode="view" />
      </div>
      <div v-if="lineBreakData && lineBreakData.includes('\n')" style="margin-top: 15px">
        <label>能量流：</label>
        <el-input v-model="lineBreakData" type="textarea" autosize disabled />
      </div>
      <template #footer>
        <el-button @click="visible = false">取消</el-button>
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import { nextTick, onUnmounted, onMounted, reactive, ref, computed } from 'vue'
import { getSites, getOperationTypeApi } from '@/server/site'
import useStorage from '@/hooks/storage'
import { format } from 'date-fns'
import { ElMessage } from 'element-plus'
import TableRender from '@/components/table'
import { getOperationLog } from '@/server/operate'
import { ElButton } from 'element-plus'
import Dialog from '@/components/dialog'
import JsonEditor from '@/components/editor/json'

const props = defineProps({
  mode: {
    type: String,
    default: 'domain',
  },
})
const emits = defineEmits(['failArr'])

const pageTitle = computed(() => (props.mode === 'site' ? '站点日志' : '操作日志'))
const tableCutHeight = computed(() => (props.mode === 'dialog' ? 180 : 300))

const { getStorage, setStorage } = useStorage()
const tableData = ref([])
const dataTableRef = ref()
const tableLoading = ref(false)
const visible = ref(false)
let colomns = ref([
  {
    label: '站点名称',
    prop: 'station_name',
  },
  {
    label: '时间',
    prop: 'time',
  },
  {
    label: '操作类型',
    prop: 'type',
  },
  {
    label: '操作人',
    prop: 'operator_name',
  },
  {
    label: '设备名称',
    prop: 'alias',
  },
  {
    label: '状态',
    prop: 'state',
  },
  {
    label: '日志详情',
    prop: 'content',
    // tooltip: true,
    render: (h, data) => {
      return h(
        'div',
        {
          style: {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          },
        },
        [JSON.stringify(data.row.content)],
      )
    },
  },
  {
    label: '操作',
    minWidth: 50,
    render: (h, data) => {
      const child = [
        h(
          ElButton,
          {
            link: true,
            type: 'primary',
            onClick: () => {
              showCannelDetail(data.row)
            },
          },
          () => '查看',
        ),
      ]
      return h('span', {}, child)
    },
  },
])

if (props.mode === 'site') {
  colomns.value = colomns.value.filter(i => i.label !== '站点名称')
}
const defaultDateStr = ref(props.mode === 'dialog' ? [] : [`${format(new Date(), 'yyyy-MM-dd')} 00:00:00`, `${format(new Date(), 'yyyy-MM-dd')} 23:59:59`])
const type = ref([])

// 表格数据查询入参
const params = ref({
  station_id: '',
  start: defaultDateStr.value[0],
  end: defaultDateStr.value[1],
  operation_type: type.value.join("','"),
  state: '',
  limit: 50,
  offset: 0,
  exculde_operation_type: "策略快照','cop",
})
let setIntervalId = null

onMounted(async () => {
  if (props.mode === 'domain') {
    await getSiteListData()
  }
  await getOperationType()
  await getAlarmList()
  if (props.mode === 'dialog') {
    setIntervalId = window.setInterval(async () => {
      await getAlarmList()
    }, 1000 * 60)
  }
  const container = dataTableRef.value?.$el.querySelector('.el-scrollbar__wrap')
  if (container) {
    container.addEventListener('scroll', handleScroll)
  }
})

onUnmounted(() => {
  const container = dataTableRef.value?.$el.querySelector('.el-scrollbar__wrap')
  if (container) {
    container.removeEventListener('scroll', handleScroll)
  }
  if (props.mode === 'dialog') {
    window.clearInterval(setIntervalId)
    setIntervalId = null
  }
})

// 获取数据列表
async function getAlarmList(val) {
  tableLoading.value = true
  try {
    if (tableData.value.length === 0) {
      params.value.offset = 0
    }
    const container = dataTableRef.value?.$el.querySelector('.el-scrollbar__wrap')
    if (!val && params.value.offset !== 0) {
      params.value.offset = 0
      tableData.value = []
      container.scrollTop = 0
    }
    if (props.mode === 'dialog' && !params.value.start) {
      params.value.start = format(new Date(new Date().getTime() - 5 * 60 * 1000), 'yyyy-MM-dd HH:mm:ss')
      params.value.end = format(new Date(), 'yyyy-MM-dd HH:mm:ss')
    }
    if (props.mode !== 'domain') {
      params.value.station_id = getStorage('activeSiteId')
    }

    const { data } = await getOperationLog(params.value)
    if (data.code === 200) {
      let arr = []
      arr = data.msg.map(i => {
        return {
          ...i,
          time: i.create_time,
          type: i.operation_type,
          alias: i.device_name,
          content: i.raw,
          station_name: i.station_name,
          state: i.state,
          id: i.id,
        }
      })
      if (val) {
        tableData.value = tableData.value.concat(arr)
      } else {
        tableData.value = arr
      }
      if (props.mode === 'dialog') {
        // console.log('tableData', tableData.value)
        let failArr = tableData.value.filter(i => i.state === '失败')
        emits('failArr', failArr)
      }
    } else {
      ElMessage.warning('数据获取失败')
    }
  } catch (error) {
    console.log(error)
    tableLoading.value = false
  }
  tableLoading.value = false
}
// 监听列表滚动 触底加载事件
function handleScroll() {
  const container = dataTableRef.value?.$el.querySelector('.el-scrollbar__wrap')
  if (container) {
    if (tableLoading.value) return
    const { scrollTop, scrollHeight, clientHeight } = container
    if (scrollTop + clientHeight >= scrollHeight - 20) {
      console.log('滚动到底部了')
      if (tableData.value.length === params.value.offset + params.value.limit) {
        params.value.offset = params.value.offset + params.value.limit
        getAlarmList('isBottom')
      }
    }
  }
}
// 时间筛选
function handleDatePicker(date) {
  defaultDateStr.value = [format(date[0], 'yyyy-MM-dd HH:mm:ss'), format(date[1], 'yyyy-MM-dd HH:mm:ss')]
  if (new Date(defaultDateStr.value[1]).getTime() - 1000 * 60 * 60 * 24 * 1 > new Date(defaultDateStr.value[0]).getTime()) {
    defaultDateStr.value = [`${format(new Date(), 'yyyy-MM-dd')} HH:mm:ss`, `${format(new Date(), 'yyyy-MM-dd')} HH:mm:ss`]
    return ElMessage.error('查询时间不能超过 1 天')
  }
  params.value.start = defaultDateStr.value[0]
  params.value.end = defaultDateStr.value[1]
  // getAlarmList()
}
// 类型筛选
function handleChange(val) {
  params.value.operation_type = val.join("','")
  // getAlarmList()
}

// 站点相关
const siteOptions = ref([])
// 获取站点列表
async function getSiteListData() {
  try {
    let userInfo = getStorage('userInfo')
    userInfo = userInfo.user_info
    const res = await getSites({
      include_hide: 0,
      userid: userInfo.user_id,
      roleids: userInfo.roleids,
    })
    if (res.data && res.data.msg) {
      siteOptions.value = res.data.msg.map(item => {
        return {
          label: item.item_label,
          value: item.id,
        }
      })
      // params.value.station_id = getStorage('activeSiteId')
    }
  } catch (error) {
    console.log(error)
  }
}

// 日志类型相关
const operationTypeOptions = ref([
  { label: '策略', value: 'strategy' },
  { label: '集群', value: 'cluster' },
  { label: '模拟', value: 'simulator' },
  { label: '自检', value: 'check' },
  { label: '检查', value: '检查' },
  { label: '运行', value: '运行' },
])
// 日志类型相关
const operationStateOptions = ref([
  { label: '启动', value: '启动' },
  { label: '成功', value: '成功' },
  { label: '失败', value: '失败' },
])
// 获取日志类型
async function getOperationType() {
  try {
    const { data } = await getOperationTypeApi()
    if (data.code === 200) {
      let arr = []
      arr = data.msg.map(i => {
        return {
          label: i,
          value: i,
        }
      })
      operationTypeOptions.value = operationTypeOptions.value.concat(arr)
    }
  } catch (error) {
    console.log(error)
  }
}

const jsonData = ref('')
const lineBreakData = ref('')
// 点击查看日志详情
function showCannelDetail(val) {
  // console.log("🚀 - val -->", val)
  jsonData.value = JSON.stringify(val.content)
  lineBreakData.value = val.content['能量流']
  visible.value = true
}

defineExpose({
  showCannelDetail,
  getAlarmList,
})
</script>

<style lang="scss" scoped>
.operation-log-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  .operation-log-body {
    flex: 1;
    min-height: 0;
    min-width: 0;
    padding: 0 4px 8px;
    box-sizing: border-box;
  }

  .operation-log-panel {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px 20px 10px;
    box-sizing: border-box;
    border: 1px solid var(--ui-panel-border);
    border-radius: 4px;
    background: radial-gradient(ellipse 70% 40% at 85% 95%, rgba(0, 200, 255, 0.06), transparent 50%),
      linear-gradient(180deg, rgba(10, 22, 40, 0.75) 0%, rgba(5, 11, 20, 0.88) 100%);
    overflow: hidden;

    .list-header {
      flex-shrink: 0;
      margin-bottom: 12px;
      min-width: 0;
    }

    .search-query {
      width: 100%;

      .search-item {
        .el-select {
          min-width: 200px;
          max-width: 100%;
        }
      }
    }

    .operation-log-table {
      flex: 1;
      min-height: 0;
      min-width: 0;
      height: 100%;
    }
  }

  &--dialog {
    height: 100%;

    .operation-log-body {
      padding: 0;
      height: 100%;
    }

    .operation-log-panel {
      padding: 0;
      border: none;
      border-radius: 0;
      background: transparent;
      height: 100%;
    }

    .list-header {
      margin-bottom: 8px;
    }
  }

  @media screen and (max-width: 900px) {
    .operation-log-panel {
      padding: 12px;

      .search-query .search-item .el-select {
        min-width: 160px;
      }
    }
  }
}
</style>
